import script from "./AdminAppView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminAppView.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__